import { Skeleton } from '@/components/ui/skeleton'
import { TableSkeleton } from './TableSkeleton'
import { cn } from '@/lib/utils'

/**
 * Generic tab/route body loading placeholder — a toolbar band followed by a
 * table skeleton. Used as the Suspense fallback while a lazily-loaded tab's
 * chunk + data resolve, so entering a tab never flashes bare "Loading…" text.
 *
 * See `.cursor/rules/loading-skeletons.mdc`.
 */
interface TabContentSkeletonProps {
  rows?: number
  columns?: number
  className?: string
}

export const TabContentSkeleton = ({
  rows = 8,
  columns = 5,
  className,
}: TabContentSkeletonProps): JSX.Element => {
  return (
    <div
      className={cn('p-6 space-y-4', className)}
      role="status"
      aria-busy="true"
      aria-live="polite"
      aria-label="Loading content"
    >
      <div className="flex items-center justify-between gap-4">
        <Skeleton className="h-6 w-48 rounded" />
        <div className="flex items-center gap-2">
          <Skeleton className="h-8 w-24 rounded-md" />
          <Skeleton className="h-8 w-24 rounded-md" />
        </div>
      </div>
      <TableSkeleton rows={rows} columns={columns} />
    </div>
  )
}
